import {Component, input} from '@angular/core'
import {MatIcon, MatIconRegistry} from '@angular/material/icon'
import {DomSanitizer} from '@angular/platform-browser'

const KdlIcons = [
  'brochure',
  'event',
  'instagram',
  'kitchen',
  'kulladal_leaf',
  'kulladal_leaf_primary',
  'steps'
] as const
export type TKdlIcon = typeof KdlIcons[number]

@Component({
  selector: 'kdl-icon',
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  imports: [
    MatIcon
  ],
  standalone: true
})
export class IconComponent {
  public icon = input.required<TKdlIcon>()

  public static setupIcons(
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer
  ) {
    iconRegistry.setDefaultFontSetClass('material-symbols-outlined')

    KdlIcons.forEach(icon => {
      iconRegistry.addSvgIcon(icon,
        sanitizer.bypassSecurityTrustResourceUrl(`assets/icon_${icon}.svg`))
    })
  }
}
